import React from 'react';
import { Flex } from '@stockx/ui';
import { LowestAskLabel, LowestAskAmount } from '../ProductTile.styles';

type PricelineProps = {
  label: string;
  amount: string;
};

const Priceline = ({ label, amount }: PricelineProps) => (
  <Flex direction="column" justifyContent="space-between" height="100%">
    <LowestAskLabel>{label}</LowestAskLabel>
    <Flex mt={1} alignItems="center" flexWrap="wrap">
      <LowestAskAmount>{amount}</LowestAskAmount>
    </Flex>
  </Flex>
);

export default Priceline;
